module.exports = __webpack_public_path__ + "img/090.ab67ae5c.png";